import { render, staticRenderFns } from "./WaitingApprovalBtns.vue?vue&type=template&id=7932cc0c&"
import script from "./WaitingApprovalBtns.vue?vue&type=script&lang=js&"
export * from "./WaitingApprovalBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports